import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDrawer } from '@angular/material/sidenav';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CountableTimeZonePipe, DocumentPreviewTypes } from 'countable@helpers';
import { FsExportService } from 'countable@services';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { SharedService } from 'src/app/components/shared/shared.service';
import { ResizeModel } from 'src/app/model/eng/resize.model';
import { ApiService } from 'src/app/services/api.service';
import { modules } from 'src/app/services/app-config';
import { TimeTrackerService } from 'src/app/services/time-tracker.service';
import { HeaderNameModel } from '../../../../model/workbook/header-name.model';
import { WbNoteModel } from '../../../../model/workbook/wb-note.model';
import { WorkbookService } from '../../../../services/workbook.service';
import { StockholderService } from './stockholdersequity.service';

export interface StockholderColumn {
  columnUUID: string;
  columnId: number;
  colName: string;
  colSortOrder: number;
  isHide: boolean;
  isFromRf: boolean;
  value: number;
}

export interface StockholderRow {
  rowUUID: string;
  rowId: number;
  rowName: string;
  rowSortOrder: number;
  year: string;
  notesHeader: string;
  notesData: any[];
  isRowDraggable: boolean;
  dynamicColumns: StockholderColumn[];
  totalStockEquity?: number;
  isPreviousYear: boolean;
  mappedCurrentYearRowUUID?: string;
  groupId: string;
  isFromRf: boolean;
}

export class Group {
  level = 0;
  parent: Group;
  expanded = true;
  totalCounts = 0;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}


@Component({
  selector: 'app-stockholdersequity',
  templateUrl: './stockholdersequity.component.html',
  styleUrls: ['./stockholdersequity.component.scss'],
  standalone: false
})
export class StockholdersequityComponent implements OnInit {

  @ViewChild('table', { static: true }) table: MatTable<StockholderRow | Group>;
  @ViewChild('limitReachedDialog') limitReachedDialog: TemplateRef<any>;
  @ViewChild('deleteConfirmDialog') deleteConfirmDialog: TemplateRef<any>;
  @ViewChild('hidingMenu') hideMenu: MatMenuTrigger;
  @ViewChild('notesFSLinkingDialog') notesFSLinkingDialog: TemplateRef<any>;
  @ViewChild('focusInputField') focusInputField: ElementRef;
  @ViewChild('rollForwardedWarningDialog') rollForwardedWarningDialog: TemplateRef<any>;

  @ViewChild('drawer') drawer: MatDrawer;

  allGroupsExpanded = true;
  isMove = false;
  isHideNotesToFS = false;
  counter = 1;
  rowCounter = 1;
  nonDefaultColumns = 0;
  dragDisabled = true;
  _alldata: StockholderRow[] = [];

  displayedColumns: string[] = [];
  groupByColumns: string[] = [];
  apiResponse: any;
  dataSource = new MatTableDataSource<StockholderRow | Group>([]);
  columnsFromApi: StockholderColumn[] = [];
  copyColumnsFromApi: StockholderColumn[] = [];
  editColumnUUID = '';
  editRowUUID = '';
  editInput = '';
  columnToDelete: StockholderColumn;
  renameColumnUUID = '';
  isSelectAll: boolean = false;
  previousDataOfEditRow: StockholderRow = {} as StockholderRow;
  hideColumnsData: StockholderColumn[] = [];
  rowToDelete: StockholderRow;
  currentYear = '';
  editYear = '';

  userData: any;
  selectedEngagementDetails: any;
  isRowEdited = false;
  dragDropData = [];
  previousIndex: number;
  clientName: string;
  headerText = ""; //'Statement of Changes in Stockholder’s equity';
  subheaderText = ""; //'For the year ended ';
  columnDraggedArray: StockholderColumn[] = [];
  initialColSortArray: number[];
  changedColSortArray: number[];
  isFooterNoteEdited = false;

  footerText: string = '';
  footerNote = "";
  notes: any = [];
  searchKeyword: string;
  notesSource: any;
  listOfRows: any = [];
  disablegreenbutton: boolean = true;
  submoduleId: number;
  engYearDetails: any;
  currEndYearDate: any;
  prevEndYearDate: any;
  prevYear = '';
  defaultRowsData: any;
  isSubheaderClicked: boolean = false;
  oldSubheaderText: string = '';
  headerNotesColumn3: string = '';
  shortCutMenuDetails: any;
  oldFooterNote: string;
  crossCheck = {
    cyCrossCheckMinuend: 0,
    pyCrossCheckMinuend: 0
  }
  headerFooterSub: Subscription;
  isNewColAdded = false;
  isColEdited = false;
  originalColHeading = '';
  private trackerService: TimeTrackerService;
  @ViewChild('colHeader') colHeader: ElementRef;

  public subscriptions: Subscription = new Subscription();
  public stockholder$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  trackobj: {
    engagementsId: any; submoduleId: number; //localStorage.getItem('submoduleid'),
    submoduleUuid: string; //this.notesSRc.id + ''//localStorage.getItem('UUID')
  };
  isTrackerOn: number;
  userInactive: Subject<any> = new Subject();

  constructor(public dialog: MatDialog, public apiService: ApiService, private fsService: FsExportService, public datePipe: DatePipe,
    public toaster: ToastrService, public cdr: ChangeDetectorRef,
    private router: Router, private sharedService: SharedService, private stockService: StockholderService,
    private wbService: WorkbookService, private countableTimeZonePipe: CountableTimeZonePipe) {
    this.userInactive.subscribe(() => {
      this.trackerService.startTimer('Idle');
    });
  }

  ngOnInit() {
    this.groupByColumns = ['year'];
    this.userData = JSON.parse(localStorage.getItem('userDetails'));
    this.selectedEngagementDetails = JSON.parse((localStorage.getItem('selectedEngagementObj')));
    this.clientName = this.selectedEngagementDetails.clientName;
    this.submoduleId = JSON.parse(localStorage.getItem('workBookSubmoduleId'));
    this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
    this.getEngagementYeardata();
    this.getStockholderHeaderNotes();

    this.headerFooterSub = this.sharedService.leftSideMenuNameChange.subscribe(response => {
      if (response) {
        this.getStockholderHeaderNotes();
      }
    });

    this.subscriptions.add(
      this.stockholder$.pipe().subscribe({
        next: stockholderData => {
          if (stockholderData) {
            let stockholderJSON = JSON.parse(stockholderData);
            stockholderJSON = stockholderJSON.stockholder;

            // Middle data
            this.apiResponse = JSON.parse(stockholderJSON["stockholderData"]);

            this.refreshPreview();
            if (Object.keys(this.apiResponse).length !== 0) {
              this.apiResponse.year1.rows.forEach(e => {
                if (e.name.includes('Balance as of') && this.apiResponse.year1.year === this.currentYear) {
                  e.formattedName = this.getFormattedDate(this.currEndYearDate, true);
                }
              });
              if (this.apiResponse?.year2) {
                this.apiResponse.year2.rows.forEach(e => {
                  if (e.name.includes('Balance as of') && this.apiResponse.year2.year === this.prevYear) {
                    e.formattedName = this.getFormattedDate(this.prevEndYearDate, true);
                  }
                });
              }

              this.mapCurrentYearToPrevYear();
              this.createDataStructure();
              this.mapDataSource();
            }
            else {
              this.toaster.info('No data available');
            }

            // Preview data
            document.getElementById("stockholder-preview").innerHTML = stockholderJSON["stockholderPreview"];

            if (this.footerText == '') {
              this.getStockholderHeaderNotes();
            } else {
              this.updateFooter(this.footerNote);
            }

          }

        }
      })
    );
    setTimeout(() => {


      this.trackobj = {
        'engagementsId': this.selectedEngagementDetails.engagementsid,
        'submoduleId': this.submoduleId,//localStorage.getItem('submoduleid'),
        'submoduleUuid': (localStorage.getItem('WUUID'))//this.notesSRc.id + ''//localStorage.getItem('UUID')
      };
      this.isTrackerOn = +localStorage.getItem('istimetrackingon');
      if (this.isTrackerOn == 0) {
        localStorage.setItem('timeTrackerObj', JSON.stringify(this.trackobj));
        this.trackerService.startTimer('Active');
      }
    }, 0);
  }

  getStockholderHeaderNotes() {
    let engId = this.selectedEngagementDetails.engagementsid.toString();
    let subModuleId = this.submoduleId;

    this.wbService.getWbHeaderNote(engId, subModuleId).subscribe({
      next: res => {
        if (res?.status === 200 && res?.data) {
          const incomeHeaderInfo = JSON.parse(res?.data);
          this.headerText = incomeHeaderInfo[0].header[0].changednameline1;
          this.subheaderText = incomeHeaderInfo[0].header[0].changednameline2;
          this.headerNotesColumn3 = incomeHeaderInfo[0].header[0].changednameline3;
          this.footerNote = incomeHeaderInfo[1].note ? incomeHeaderInfo[1].note[0].note : '';
          this.sharedService.StockholderPreviewheaderInfo.next(incomeHeaderInfo);
          localStorage.setItem('refreshFinancialStatements-STH', 'success');
          this.getFSNotes();
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  saveHeaderNote() {
    const headerNameModel: HeaderNameModel = {
      subModuleId: this.submoduleId,
      engId: this.selectedEngagementDetails.engagementsid.toString(),
      changedNameLine2: this.subheaderText,
      changedNameLine3: this.headerNotesColumn3,
      isDelete: 0
    }

    this.wbService.saveChangeWbHeaderName(headerNameModel).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toaster.success('Header details updated successfully');
          this.isSubheaderClicked = false;
          this.getStockholderHeaderNotes();
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  editFooterNotes() {
    this.focusInput();
    this.oldFooterNote = this.footerNote;
    this.isFooterNoteEdited = true;
  }

  cancelEditFooterNote() {
    this.footerNote = this.oldFooterNote
    this.isFooterNoteEdited = false;
  }

  focusInput() {
    setTimeout(() => {
      this.focusInputField.nativeElement.focus();
    }, 0);
  }

  saveFooterNote() {
    this.footerNote = this.footerNote.trim();
    if (!this.footerNote) {
      this.toaster.warning("Please enter the notes");
      return;
    }
    if (this.footerNote.length > 250) {
      this.toaster.warning("Text length is limited to 250 characters");
      return;
    }
    const wbNoteModel: WbNoteModel = {
      subModuleId: this.submoduleId,
      engId: this.selectedEngagementDetails.engagementsid.toString(),
      note: this.footerNote,
      isDelete: 0
    }
    this.wbService.saveWbNote(wbNoteModel).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          localStorage.setItem('isfooterUpdated', this.footerNote);
          this.toaster.success('Footer Details Updated Successfully');
          this.isFooterNoteEdited = false;
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  getEngagementYeardata() {
    this.apiService.getEngagementYearDetails(this.selectedEngagementDetails.engagementsid.toString()).subscribe(response => {
      if (response) {
        this.engYearDetails = response;
        this.currentYear = this.engYearDetails[0].acctyear;
        this.currEndYearDate = this.engYearDetails[0].acctdate;
        this.prevYear = this.engYearDetails[1]?.acctyear ? this.engYearDetails[1]?.acctyear : '0';
        this.prevEndYearDate = this.engYearDetails[1]?.acctdate ? this.engYearDetails[1]?.acctdate : '';
        this.getStockholderDefaultRows();
      }
    }, error => {

      this.toaster.error(error.error);
    });
  }

  getStockholderDefaultRows() {
    var stockdataObj =
    {
      'engagementsId': this.selectedEngagementDetails.engagementsid.toString(),
      'currentYear': this.currentYear,
      'previousYear': this.prevYear
    }
    this.apiService.getStockholderDefaults(stockdataObj).subscribe(resp => {
      if (resp) {
        this.defaultRowsData = JSON.parse(resp);
        if (Object.keys(this.defaultRowsData).length !== 0) {
          this.defaultRowsData.defaults.forEach(e => {
            if (e.rowUUID == "cyCrossCheckMinuend") {
              this.crossCheck.cyCrossCheckMinuend = e.value;
            }
            if (e.rowUUID == "pyCrossCheckMinuend") {
              this.crossCheck.pyCrossCheckMinuend = e.value;

            }
          });
          this.fetchStockHolderData();
          // this.getFSNotes();
        }
        else {
          this.toaster.info('No data available');
        }
      } 
    }, error => {
      this.toaster.error(error.error);
    });
  }

  fetchStockHolderData() {
    this.subscriptions.add(
      this.fsService.fetchFSDocPreview(DocumentPreviewTypes.STOCK_HOLDERS).subscribe({
        next: res => {
          this.stockholder$.next(res);
        }
      })
    );
  }

  mapDataSource() {
    this.dataSource.data = this.addGroups(this._alldata, this.groupByColumns);
    this.dataSource.filterPredicate = this.customFilterPredicate.bind(this);
    this.dataSource.filter = performance.now().toString();
  }

  mapCurrentYearToPrevYear() {
    if (this.apiResponse?.year2) {      //If prev Year data exists
      this.apiResponse.year2.rows.forEach(ele => {
        if (ele.isPreviousYear) {
          const currRow = this.apiResponse.year1.rows.filter(val => val.groupId === ele.groupId);
          if (currRow.length > 0) {
            ele.mappedCurrentYearRowUUID = currRow[0].rowUUID;
          }
        }
      });
    }
  }

  createDataStructure() {
    this._alldata = [];
    this.displayedColumns = [];
    let yearKeys = Object.keys(this.apiResponse);
    yearKeys = yearKeys.filter(e => e !== 'columns');
    let apiColumns = this.apiResponse['columns'];
    this.nonDefaultColumns = apiColumns.length - 1; //because one is default i.e. retained earnings

    yearKeys.forEach(val => {
      const yearData = this.apiResponse[val];
      if (yearData.rows.length) {
        const sortArray = (yearData.rows.map(rw => parseInt(rw.sortOrder))).sort((a, b) => a - b);
        let highestSortOrder = sortArray[sortArray.length - 1];
        yearData.rows.forEach(eachRow => {
          const defColVal = this.defaultRowsData.defaults.filter(val => val.rowUUID === eachRow.rowUUID);
          if (defColVal.length) {
            const defObj = {
              colId: defColVal[0].columnUUID,
              value: defColVal[0].value,
              valueId: 0
            }
            eachRow.values.push(defObj);
          }
          const rowColumnsObj = this.convertColumnArrayToObject(eachRow.values, 'colId');

          const mappedColumns = this.mapColumnsToInterface(apiColumns, rowColumnsObj);
          this.columnsFromApi = JSON.parse(JSON.stringify(mappedColumns));
          this.copyColumnsFromApi = JSON.parse(JSON.stringify(mappedColumns));
          this.initialColSortArray = this.copyColumnsFromApi.map(col => col.colSortOrder);
          this.changedColSortArray = [...this.initialColSortArray];

          let rowObj: StockholderRow = {
            rowId: eachRow.rowId,
            rowUUID: eachRow.rowUUID,
            rowName: (eachRow.name.includes('Balance as of')) ? ((yearData.year === this.currentYear) ? this.getFormattedDate(this.currEndYearDate, true) : this.getFormattedDate(this.prevEndYearDate, true)) : eachRow.name,
            rowSortOrder: eachRow.sortOrder,
            year: yearData.year,
            notesHeader: 'Notes to FS',
            notesData: eachRow.notes,
            isRowDraggable: false,
            isPreviousYear: eachRow.isPreviousYear,
            dynamicColumns: [...mappedColumns],
            groupId: eachRow.groupId,
            isFromRf: eachRow.isFromRf
          };

          if (rowObj.isPreviousYear) {
            rowObj.mappedCurrentYearRowUUID = eachRow.mappedCurrentYearRowUUID;
          }

          this._alldata.push(rowObj);

        });

        //Add 'Add Row' btn
        let rowObj1: StockholderRow = {
          rowId: Math.floor(Math.random() * 25),
          rowUUID: 'addRowBtn',
          rowName: 'Add Row',
          rowSortOrder: ++highestSortOrder,
          year: yearData.year,
          notesHeader: 'Notes to FS',
          notesData: [],
          isRowDraggable: false,
          isPreviousYear: false,
          dynamicColumns: [],
          groupId: 'addRowBtn',
          isFromRf: false
        };
        this._alldata.push(rowObj1);

        //Add 'Total Balance' row
        let rowObj2: StockholderRow = {
          rowId: Math.floor(Math.random() * 25),
          rowUUID: 'endTotalBal',
          rowName: (yearData.year === this.currentYear) ? this.getFormattedDate(this.currEndYearDate) : this.getFormattedDate(this.prevEndYearDate),
          rowSortOrder: ++highestSortOrder,
          year: yearData.year,
          notesHeader: 'Notes to FS',
          notesData: [],
          isRowDraggable: false,
          isPreviousYear: false,
          dynamicColumns: [],
          groupId: 'endTotalBal',
          isFromRf: false
        };
        this._alldata.push(rowObj2);

        //Add 'Cross check' row
        let rowObj3: StockholderRow = {
          rowId: Math.floor(Math.random() * 25),
          rowUUID: 'crossCheck',
          rowName: '',
          rowSortOrder: ++highestSortOrder,
          year: yearData.year,
          notesHeader: 'Notes to FS',
          notesData: [],
          isRowDraggable: false,
          isPreviousYear: false,
          dynamicColumns: [],
          groupId: 'crossCheck',
          isFromRf: false
        };
        this._alldata.push(rowObj3);
      }
    });

    this._alldata.sort((a, b) => (a.rowSortOrder) - (b.rowSortOrder));
    this.setDisplayedColumns(apiColumns);
  }

  getFormattedDate(date: string, minusOneYear?: boolean) {
    if (!minusOneYear) {
      return `Balance as of ${this.countableTimeZonePipe.transform(date, 'MMMM d, yyyy', 'UTC')}`;
    } else {
      return `Balance as of ${this.countableTimeZonePipe.transform(date, 'MMMM d, yyyy', 'UTC', true, true)}`;
    }
  }

  setDisplayedColumns(columns) {
    columns.sort((a, b) => (a.sortOrder - b.sortOrder));
    this.displayedColumns = columns.filter(cd => !cd.isHide).map(cd => cd.columnUUID);
    this.displayedColumns.splice(0, 0, 'description', 'notes');
    const arrayLength = this.displayedColumns.length;
    this.displayedColumns.splice(arrayLength, 0, 'totStockEq');
  }

  mapColumnsToInterface(columnArr, columnObj) {
    const mappedColumns: StockholderColumn[] = [];
    columnArr.forEach(item => {
      let eachColumn: StockholderColumn = {
        columnUUID: item.columnUUID,
        columnId: item.columnId,
        colName: item.name,
        colSortOrder: item.sortOrder,
        isHide: item.isHide,
        isFromRf: item.isFromRf,
        value: columnObj[item.columnUUID] || 0
      }
      mappedColumns.push(eachColumn);
    });

    mappedColumns.sort((a, b) => {
      return (a.colSortOrder) - (b.colSortOrder);
    });
    return mappedColumns;
  }

  convertColumnArrayToObject(arr, key) {
    let output = {};
    arr.forEach(item => {
      output[item[key]] = item['value'];
    });
    return output;
  }

  getColValue(element: StockholderRow, columnUUID: string) {
    const columns = element.dynamicColumns;
    const index = columns.findIndex(col => col.columnUUID === columnUUID);
    if (index !== -1) {
      return (columns[index].value);
    } else {
      return '';
    }
  }

  setColvalue(element: StockholderRow, columnUUID: string, value: number) {
    const columns = element.dynamicColumns;
    const index = columns.findIndex(col => col.columnUUID === columnUUID);
    if (index !== -1) {
      columns[index].value = (value < 0) ? this.roundUpNegativeValue(value) : Math.round(value);
    }

    let yearKeys = Object.keys(this.apiResponse);
    yearKeys = yearKeys.filter(e => e !== 'columns');

    yearKeys.forEach(val => {
      const yearData = this.apiResponse[val];
      const rowIndex = yearData.rows.findIndex(row => row && row.rowUUID === element.rowUUID);
      if (rowIndex > -1) {
        const index = yearData.rows[rowIndex].values.findIndex(col => col.colId === columnUUID);
        if (index > -1) {
          this.apiResponse[val].rows[rowIndex].values[index].value = (value < 0) ? this.roundUpNegativeValue(value) : Math.round(value);
        }
      }
    });
    this.createDataStructure();
    // this.mapDataSource();
  }

  roundUpNegativeValue(val: number): number {
    val = val * -1;
    val = Math.round(val);
    val = val * -1;
    return val;
  }

  getTotStockEq(element: StockholderRow): number {
    const hiddenCols = this.columnsFromApi.filter(col => col.isHide).map(val => val.columnUUID);
    const columns = element.dynamicColumns;
    const values = columns.map(col => {
      return (!hiddenCols.includes(col.columnUUID)) ? col.value : 0;
    });
    const sum = values.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);
    element.totalStockEquity = sum;
    return sum;
  }

  getTotEndBalance(year: number, columnUUID: string): number {
    const yearData = this.dataSource.data.filter(row => row && row['year'] === year && row['rowUUID'] && !['addRowBtn', 'endTotalBal', 'crossCheck'].includes(row['rowUUID']));
    let cols = []
    yearData.forEach(row => {
      cols.push(row['dynamicColumns'].filter(val => val.columnUUID === columnUUID)[0]);
    })
    const values = cols.map(col => col.value);
    return values.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);
  }

  getTotEndBalStockEq(obj: any): number {
    let sum = 0;
    if (obj.rowUUID === 'crossCheck') {
      let total = 0;
      this.dataSource.data.forEach(row => {
        if (row['year'] === obj.year && row['totalStockEquity']) {
          total += row['totalStockEquity'];
        }
      });
      if (obj.year == this.currentYear) {
        sum = this.crossCheck.cyCrossCheckMinuend - total;
      } else if (obj.year === this.prevYear) {
        sum = this.crossCheck.pyCrossCheckMinuend - total;
      }


    } else {
      this.dataSource.data.forEach(row => {
        if (row['year'] === obj.year && row['totalStockEquity']) {
          sum += row['totalStockEquity'];
        }
      });
    }

    return sum;
  }

  isCrossCheckValueZero(row: StockholderRow): boolean {
    return (row.rowUUID === 'crossCheck' && this.getTotEndBalStockEq(row) === 0) ? true : false;
  }

  showFormattedNumber(data: number) {
    if (data > 0) {
      return data.toLocaleString('en-us');
    } else if (data < 0) {
      const absoluteNumber = data * -1;
      const formatted = absoluteNumber.toLocaleString('en-US');
      return '(' + formatted + ')';
    } else {
      return '-';
    }
  }

  addColumn() {
    if (this.nonDefaultColumns < 3) {
      this.isNewColAdded = true;
      const sortArray = (this.columnsFromApi.map(cl => cl.colSortOrder)).sort((a, b) => a - b);
      let lowestSortOrder = sortArray[0];
      let newColumn: any = {
        "columnId": this.counter,
        "columnUUID": "newCol" + this.counter,
        "name": "",
        "sortOrder": --lowestSortOrder,
        "isHide": false
      };
      this.counter++;
      this.apiResponse.columns.splice(0, 0, newColumn);

      let yearKeys = Object.keys(this.apiResponse);
      yearKeys = yearKeys.filter(e => e !== 'columns');

      yearKeys.forEach(val => {
        const yearData = this.apiResponse[val];
        yearData.rows.forEach(eachRow => {
          let obj = {
            "colId": newColumn.columnUUID,
            "value": 0,
            "acctYear": eachRow.year
          }
          eachRow.values.push(obj);
        });
      });

      this.editColumnUUID = newColumn.columnUUID;
      this.createDataStructure();
      this.mapDataSource();
      setTimeout(() => document.getElementById('colHeader').focus(), 0);
    } else {
      const dialogRef = this.dialog.open(this.limitReachedDialog, {});
      dialogRef.afterClosed().subscribe();
    }
  }

  saveColumn() {
    let column = this.columnsFromApi.filter(val => val.columnUUID === this.editColumnUUID)[0];
    let rowvalues = [];
    //fetch rows
    this.dataSource.data.forEach(row => {
      if (row && row['rowUUID'] && !(['addRowBtn', 'endTotalBal', 'crossCheck'].includes(row['rowUUID']))) {
        let item = {
          "rowUUID": row['rowUUID'],
          "value": row['dynamicColumns'].filter(col => col.columnUUID === this.editColumnUUID)[0]?.value,
          "acctYear": row['year']
        }
        rowvalues.push(item);
      }
    })

    //create saving object
    let data = {
      "loginId": this.userData.useracctid,
      "col": [{
        "id": (column.columnUUID.includes('newCol')) ? 0 : column.columnId,
        "columnUUID": (column.columnUUID.includes('newCol')) ? "0" : column.columnUUID,
        "engagementsId": this.selectedEngagementDetails.engagementsid,
        "columnName": column.colName,
        "sortOrder": column.colSortOrder,
        "isColumnHidden": column.isHide,
        "values": rowvalues
      }]
    };

    if (column.columnUUID.includes('newCol')) {
      delete data.col[0].id;
    }

    this.apiService.saveStockholderColumn(data).subscribe(resp => {
      if (resp) {
        this.toaster.success("Column saved successfully");
        this.editColumnUUID = '';
        this.isNewColAdded = false;
        this.fetchStockHolderData();
      }
    }, error => {
      this.editColumnUUID = '';
      this.isNewColAdded = false;
      this.toaster.warning(error.error);
    });
  }

  saveUpdateColumn(column: StockholderColumn) {
    if (this.isNewColAdded) {
      this.saveColumn();
    } else if (this.isColEdited) {
      this.updateColName(column);
    }
  }

  cancelSaveColumn(column: StockholderColumn) {
    if (this.isNewColAdded) {
      this.deleteColumnFromData(this.editColumnUUID);
      this.editColumnUUID = '';
      this.isNewColAdded = false;
    } else if (this.isColEdited) {
      column.colName = this.originalColHeading;
      this.renameColumnUUID = '';
      this.isColEdited = false;
      this.originalColHeading = '';
    }
  }

  createNewRowObjectforUI(row: StockholderRow): StockholderRow {
    const columnsForRow: StockholderColumn[] = [];

    this.columnsFromApi.forEach(item => {
      let eachColumn: StockholderColumn = {
        columnUUID: item.columnUUID,
        columnId: item.columnId,
        colName: item.colName,
        colSortOrder: item.colSortOrder,
        isHide: item.isHide,
        isFromRf: item.isFromRf,
        value: 0
      }
      columnsForRow.push(eachColumn);
    });

    let rowObj: StockholderRow = {
      rowId: this.rowCounter,
      rowUUID: "newRow" + this.rowCounter,
      rowName: "",
      rowSortOrder: 999,
      year: row.year,
      notesHeader: 'Notes to FS',
      notesData: [],
      isRowDraggable: true,
      isPreviousYear: (row.year === this.currentYear) ? false : true,
      dynamicColumns: [...columnsForRow],
      groupId: "newRow" + this.rowCounter,
      isFromRf: false
    };

    this.rowCounter++;
    return rowObj;
  }

  addNewRow(row: StockholderRow, index?: number) {
    this.editYear = row.year;
    if (row.year !== this.currentYear) {
      let prevYearRowObj = this.createNewRowObjectforUI(row);
      prevYearRowObj.mappedCurrentYearRowUUID = "newRow" + this.rowCounter;
      this.dataSource.data.splice(index, 0, prevYearRowObj);
      this.editRowUUID = prevYearRowObj.mappedCurrentYearRowUUID;

      const currYearIndex = this.dataSource.data.findIndex(val => val['year'] === this.currentYear && val['rowUUID'] == 'addRowBtn');
      let currYearRowObj = this.createNewRowObjectforUI(this.dataSource.data[currYearIndex] as StockholderRow);
      this.dataSource.data.splice(currYearIndex, 0, currYearRowObj);
    } else {
      let rowObj = this.createNewRowObjectforUI(row);
      this.editRowUUID = rowObj.rowUUID;
      this.dataSource.data.splice(index, 0, rowObj);
    }

    this.dataSource.filter = "";
  }

  updateRowName(row: StockholderRow, value: string) {
    row.rowName = value;
    if (row.year !== this.currentYear) {
      if (!this.isRowEdited) {
        const index = this.dataSource.data.findIndex(val => val['rowUUID'] === this.editRowUUID);
        this.dataSource.data[index]['rowName'] = value;
      }
    }
  }

  isSaveRowDisabled(): boolean {
    if (this.editRowUUID) {
      const index = this.dataSource.data.findIndex(row => row['rowUUID'] === this.editRowUUID);
      if (index > -1) {
        return (this.dataSource.data[index]['rowName']).trim() ? false : true;
      }
    }
    return false
  }

  isSaveColDisabled(): boolean {
    if (this.editColumnUUID) {
      const index = this.apiResponse.columns.findIndex(col => col['columnUUID'] === this.editColumnUUID);
      if (index > -1) {
        return (this.apiResponse.columns[index]['name']).trim() ? false : true;
      }
    }
    return false
  }

  setColHeader(column: StockholderColumn) {
    if (this.editColumnUUID) {
      this.apiResponse.columns.filter(col => col.columnUUID === column.columnUUID)[0].name = column.colName;
      this.columnsFromApi.filter(col => col.columnUUID === column.columnUUID)[0].colName = column.colName;
    }
  }

  createRowObjectForSaving(rowsData: StockholderRow[], isDeleted: boolean, columnsRequired: boolean, sortOrder?: number) {

    let data = {
      "loginId": this.userData.useracctid,
      "row": []
    };
    rowsData.forEach(row => {
      const colValues = row.dynamicColumns.map(col => ({ "columnUUID": col.columnUUID, "value": col.value, "isUpdate": this.isRowEdited ? 1 : 0 }));
      let obj = {
        "id": (row.rowUUID.includes('newRow')) ? 0 : row.rowId,
        "rowUUID": (row.rowUUID.includes('newRow')) ? "0" : row.rowUUID,
        "engagementsId": this.selectedEngagementDetails.engagementsid,
        "acctYear": row.year,
        "rowName": row.rowName,
        "isDeleted": isDeleted,
        "sortOrder": sortOrder ? sortOrder : row.rowSortOrder,
        "isPreviousYear": row.isPreviousYear,
        "groupId": row.groupId,
        "isFromRf": row.isFromRf,
        "values": colValues
      };

      if (!columnsRequired) {
        delete obj.values;
      }

      if (row.rowUUID.includes('newRow')) {
        delete obj.id;
      }

      if (["1", "2", "3", "4"].includes(obj.rowUUID)) {
        delete obj.engagementsId;
        delete obj.acctYear;
      }
      data.row.push(obj);
    });

    return data;
  }

  saveRow(year: string) {
    const arrayOfRows: StockholderRow[] = [];
    let sortOrder;
    if (!this.isRowEdited) {
      if (year !== this.currentYear) {
        const prevIndex = this.dataSource.data.findIndex(row => row && row['mappedCurrentYearRowUUID'] === this.editRowUUID);
        arrayOfRows.push(this.dataSource.data[prevIndex] as StockholderRow);
      }
      const index = this.dataSource.data.findIndex(row => row && row['rowUUID'] === this.editRowUUID);
      if (index > -1) {
        sortOrder = this.dataSource.data[index - 1]['rowSortOrder'] + 1;
        arrayOfRows.push(this.dataSource.data[index] as StockholderRow);
      }

    } else {
      const index = this.dataSource.data.findIndex(row => row && row['rowUUID'] === this.editRowUUID);
      arrayOfRows.push(this.dataSource.data[index] as StockholderRow);

      if (year !== this.currentYear) {
        const currIndex = this.dataSource.data.findIndex(row => row && row['rowUUID'] === this.dataSource.data[index]['mappedCurrentYearRowUUID']);
        if (currIndex > -1) {
          this.dataSource.data[currIndex]['rowName'] = this.dataSource.data[index]['rowName'];
          arrayOfRows.push(this.dataSource.data[currIndex] as StockholderRow);
        }
      } else {
        const prevIndex = this.dataSource.data.findIndex(row => row && row['mappedCurrentYearRowUUID'] === this.dataSource.data[index]['rowUUID']);
        if (prevIndex > -1) {
          this.dataSource.data[prevIndex]['rowName'] = this.dataSource.data[index]['rowName'];
          arrayOfRows.push(this.dataSource.data[prevIndex] as StockholderRow);
        }
      }
    }
    const rowObject = this.createRowObjectForSaving(arrayOfRows, false, true, sortOrder);

    this.apiService.saveStockholderRow(rowObject).subscribe(resp => {
      if (resp) {
        this.toaster.success("Row saved successfully");
        this.editRowUUID = '';
        this.editYear = '';
        this.isRowEdited = false;
        this.fetchStockHolderData();
      }
    }, error => {
      this.toaster.warning(error.error);
    });
  }

  cancelSaveRow(editRowUUID: string, year: string) {
    const index = this.dataSource.data.findIndex(row => row && row['rowUUID'] === editRowUUID);
    if (editRowUUID.includes('newRow')) {
      this.dataSource.data.splice(index, 1);
    } else {
      this.dataSource.data.splice(index, 1, this.previousDataOfEditRow);
    }
    if (year !== this.currentYear) {
      const prevIndex = this.dataSource.data.findIndex(row => row && row['mappedCurrentYearRowUUID'] === editRowUUID);
      if (prevIndex > -1) {
        this.dataSource.data.splice(prevIndex, 1);
      }
    }
    this.previousDataOfEditRow = {} as StockholderRow;
    this.editRowUUID = '';
    this.editYear = '';
    this.dataSource.filter = "";
    this.isRowEdited = false;
  }

  editRow(row: StockholderRow) {
    this.previousDataOfEditRow = JSON.parse(JSON.stringify(row));
    if (row.isFromRf) {
      const dialogRef = this.dialog.open(this.rollForwardedWarningDialog, {});
      dialogRef.afterClosed().subscribe();
    } else {
      this.editRowUUID = row.rowUUID;
      this.editYear = row.year;
      this.isRowEdited = true;
    }
  }

  editRollForwRows() {
    this.editRowUUID = this.previousDataOfEditRow.rowUUID;
    this.editYear = this.previousDataOfEditRow.year;
    this.isRowEdited = true;
  }

  cancelEditRollForwRows() {
    this.previousDataOfEditRow = {} as StockholderRow;
  }

  openDeleteRowDialog(row: StockholderRow) {
    const dialogRef = this.dialog.open(this.deleteConfirmDialog, { data: { text: "Are you sure you want to delete the row?", toDelete: 'Row' } });
    this.rowToDelete = row;
  }

  deleteRow() {
    const rowObject = this.createRowObjectForSaving([this.rowToDelete], true, false, this.rowToDelete.rowSortOrder);

    this.apiService.saveStockholderRow(rowObject).subscribe(resp => {
      if (resp) {
        this.toaster.success("Row deleted successfully");
        this.rowToDelete = {} as StockholderRow
        this.fetchStockHolderData();
      }
    }, error => {
      this.toaster.warning(error.error);
    });
  }

  editColName(column: StockholderColumn) {
    this.isColEdited = true;
    this.originalColHeading = column.colName;
    this.renameColumnUUID = column.columnUUID;
    setTimeout(() => document.getElementById('colHeader').focus(), 0);
  }

  updateColName(column: StockholderColumn) {
    if (column.colName.trim() === '') {
      this.toaster.error('Column name cannot be blank');
      this.renameColumnUUID = '';
      return;
    }
    if (this.originalColHeading === column.colName) {
      this.renameColumnUUID = '';
      return;
    }

    let data = this.createSaveColumnObject([column], false);

    this.apiService.saveStockholderColumn(data).subscribe(resp => {
      if (resp) {
        this.apiResponse.columns.filter(col => col.columnUUID === column.columnUUID)[0].name = column.colName;
        this.toaster.success("Column renamed successfully");
        this.renameColumnUUID = '';
        this.isColEdited = false;
        this.originalColHeading = '';
        this.fetchStockHolderData();
      }
    }, error => {
      this.renameColumnUUID = '';
      column.colName = this.originalColHeading;
      this.apiResponse.columns.filter(col => col.columnUUID === column.columnUUID)[0].name = this.originalColHeading;
      this.isColEdited = false;
      this.originalColHeading = '';
      this.toaster.warning(error.error);
    });
  }

  createSaveColumnObject(columns: StockholderColumn[], isDeleted: boolean) {
    const colsObj = [];

    columns.forEach(col => {
      let eachCol = {
        "columnUUID": col.columnUUID,
        "id": col.columnId,
        "engagementsId": this.selectedEngagementDetails.engagementsid,
        "columnName": col.colName,
        "isDeleted": isDeleted,
        "sortOrder": col.colSortOrder,
        "isColumnHidden": col.isHide,
        "isFromRf": col.isFromRf
      };

      if (eachCol.columnUUID === "1") {
        delete eachCol.engagementsId;
      }

      colsObj.push(eachCol);
    });

    let data = {
      "loginId": this.userData.useracctid,
      "col": JSON.parse(JSON.stringify(colsObj))
    };

    return data;
  }

  openDeleteColDialog(column: StockholderColumn) {
    const dialogRef = this.dialog.open(this.deleteConfirmDialog, { data: { text: "Are you sure you want to delete the column?", toDelete: 'Column' } });
    this.columnToDelete = column;
  }

  deleteColumn() {
    let deleteColObj = this.createSaveColumnObject([this.columnToDelete], true);

    this.apiService.saveStockholderColumn(deleteColObj).subscribe(resp => {
      if (resp) {
        this.toaster.success("Column deleted successfully");
        this.deleteColumnFromData(this.columnToDelete.columnUUID);
        this.columnToDelete = {} as StockholderColumn;
        this.fetchStockHolderData();
      }
    }, error => {
      this.columnToDelete = {} as StockholderColumn;
      this.toaster.warning(error.error);
    });
  }

  deleteColumnFromData(editColumnUUID: string) {
    const colIndex = this.apiResponse.columns.findIndex(col => col.columnUUID === editColumnUUID);
    this.apiResponse.columns.splice(colIndex, 1);

    let yearKeys = Object.keys(this.apiResponse);
    yearKeys = yearKeys.filter(e => e !== 'columns');

    yearKeys.forEach(val => {
      this.apiResponse[val].rows.forEach(eachRow => {
        const index = eachRow.values.findIndex(obj => obj.colId === editColumnUUID);
        if (index > -1) {
          eachRow.values.splice(index, 1);
        }
      });
    });
    this.createDataStructure();
    this.mapDataSource();
  }

  closeHide() {
    this.hideMenu.closeMenu();
    this.copyColumnsFromApi = JSON.parse(JSON.stringify(this.columnsFromApi));
  }

  onHideColumn() {
    let toastMessage = '';
    let hideColObj;
    if (this.columnDraggedArray.length && this.hideColumnsData.length) {
      this.columnDraggedArray.forEach(col => {
        const index = this.hideColumnsData.findIndex(val => val.columnUUID === col.columnUUID);
        if (index > -1) {
          col.isHide = this.hideColumnsData[index].isHide;
        }
      });
      hideColObj = this.createSaveColumnObject(this.columnDraggedArray, false);
      if (hideColObj.col.every(val => val.isColumnHidden === false)) {
        toastMessage = 'Columns rearranged & unhidden successfully';
      } else {
        toastMessage = 'Columns rearranged & hidden successfully';
      }
    }
    else if (this.hideColumnsData.length === 0) {
      toastMessage = 'Columns rearranged successfully';
      hideColObj = this.createSaveColumnObject(this.columnDraggedArray, false);
    } else {
      hideColObj = this.createSaveColumnObject(this.hideColumnsData, false);
      if (hideColObj.col.every(val => val.isColumnHidden === false)) {
        toastMessage = 'Columns unhidden successfully';
      } else {
        toastMessage = 'Columns hidden successfully';
      }
    }

    this.apiService.saveStockholderColumn(hideColObj).subscribe(resp => {
      if (resp) {
        this.toaster.success(toastMessage);
        this.hideColumnsData = [];
        this.columnDraggedArray = [];
        this.hideMenu.closeMenu();
        this.fetchStockHolderData();
      }
    }, error => {
      this.toaster.warning(error.error);
    });
  }

  onChangeHide(column: StockholderColumn) {
    const index = this.hideColumnsData.findIndex(col => col.columnUUID === column.columnUUID);
    if (index === -1) {
      this.hideColumnsData.push(column);
    } else {
      this.hideColumnsData.splice(index, 1);
    }
  }

  onSelectAllChecked(event) {
    this.hideColumnsData = [];
    this.copyColumnsFromApi.forEach(col => {
      if (col.columnUUID !== '1') {
        col.isHide = (event.checked) ? true : false;
        this.hideColumnsData.push(col);
      }
    });
  }

  clearAllhide() {
    this.hideColumnsData = [];
    this.copyColumnsFromApi.forEach(col => {
      if (col.columnUUID !== '1') {
        col.isHide = false;
        this.hideColumnsData.push(col);
      }
    });
  }

  isAllSelected() {
    const newArray = this.copyColumnsFromApi.filter(col => col.columnUUID !== '1');
    if (newArray.length) {
      return newArray.every(col => col.isHide);
    }
    return false;
  }

  isApplyHideDisabled() {
    let data1 = this.columnsFromApi.reduce(
      (obj, item) => Object.assign(obj, { [item.columnUUID]: item.isHide }), {});

    let data2 = this.copyColumnsFromApi.reduce(
      (obj, item) => Object.assign(obj, { [item.columnUUID]: item.isHide }), {});

    const objectsEqual = (object1, object2) =>
      Object.keys(object1).length === Object.keys(object2).length
      && Object.keys(object1).every(p => object1[p] === object2[p]);

    return objectsEqual(data1, data2) && (this.initialColSortArray && this.changedColSortArray && this.initialColSortArray.every((val, idx) => val === this.changedColSortArray[idx]));
  }

  isMainHideBtnDisabled() {
    return (this.editColumnUUID === '' && this.editRowUUID === '' && this.renameColumnUUID === '') ? false : true;
  }

  isColEditable() {
    return this.editColumnUUID ? true : false;
  }

  isRowEditable(year: string) {
    return this.editRowUUID && year === this.editYear ? true : false;
  }

  notAnAddAndTotalRow(row: StockholderRow): boolean {
    return row.rowUUID !== 'addRowBtn' && row.rowUUID !== 'endTotalBal' && row.rowUUID !== 'crossCheck';
  }

  isRowInAddMode(row: StockholderRow): boolean {
    return (row.rowUUID === this.editRowUUID || row.mappedCurrentYearRowUUID === this.editRowUUID) && !this.isRowEdited;
  }

  isAddRowBtn(row: StockholderRow): boolean {
    return row.rowUUID === 'addRowBtn'
  }

  isColumnRetainedEarning(column: StockholderColumn): boolean {
    return column.columnUUID === '1';
  }

  isColumnInEditMOde(column: StockholderColumn): boolean {
    return column.columnUUID === this.editColumnUUID;
  }

  applyRowActionIcons(row: StockholderRow): boolean {
    return !(['addRowBtn', 'endTotalBal', 'crossCheck', '1', '2', '3', '4'].includes(row.rowUUID));
  }

  isRowInEditMode(row: StockholderRow) {
    return row.rowUUID === this.editRowUUID && row.year === this.editYear ? true : false;
  }

  isDefaultRow(row: StockholderRow) {
    return ["1", "2", "3", "4"].includes(row.rowUUID);
  }

  //Grouping Code Starts here

  groupBy(event, column) {
    event.stopPropagation();
    this.checkGroupByColumn(column.field, true);
    this.dataSource.data = this.addGroups(this._alldata, this.groupByColumns);
    this.dataSource.filter = performance.now().toString();
  }

  checkGroupByColumn(field, add) {
    let found = null;
    for (const column of this.groupByColumns) {
      if (column === field) {
        found = this.groupByColumns.indexOf(column, 0);
      }
    }
    if (found != null && found >= 0) {
      if (!add) {
        this.groupByColumns.splice(found, 1);
      }
    } else {
      if (add) {
        this.groupByColumns.push(field);
      }
    }
  }

  unGroupBy(event, column) {
    event.stopPropagation();
    this.checkGroupByColumn(column.field, false);
    this.dataSource.data = this.addGroups(this._alldata, this.groupByColumns);
    this.dataSource.filter = performance.now().toString();
  }

  // below is for grid row grouping
  customFilterPredicate(data: any | Group, filter: string): boolean {
    return (data instanceof Group) ? data.visible : this.getDataRowVisible(data);
  }

  getDataRowVisible(data: any): boolean {
    const groupRows = this.dataSource.data.filter(
      row => {
        if (!(row instanceof Group)) {
          return false;
        }
        let match = true;
        this.groupByColumns.forEach(column => {
          if (!row[column] || !data[column] || row[column] !== data[column]) {
            match = false;
          }
        });
        return match;
      }
    );

    if (groupRows.length === 0) {
      return true;
    }
    const parent = groupRows[0] as Group;
    return parent.visible && parent.expanded;
  }

  groupHeaderClick(row) {
    row.expanded = !row.expanded;
    this.dataSource.filter = performance.now().toString();
  }

  addGroups(data: any[], groupByColumns: string[]): any[] {
    const rootGroup = new Group();
    rootGroup.expanded = true;
    return this.getSublevel(data, 0, groupByColumns, rootGroup);
  }

  getSublevel(data: any[], level: number, groupByColumns: string[], parent: Group): any[] {
    if (level >= groupByColumns.length) {
      return data;
    }
    const groups = this.uniqueBy(
      data.map(
        row => {
          const result = new Group();
          result.level = level + 1;
          result.parent = parent;
          for (let i = 0; i <= level; i++) {
            result[groupByColumns[i]] = row[groupByColumns[i]];
          }
          return result;
        }
      ),
      JSON.stringify);

    const currentColumn = groupByColumns[level];
    let subGroups = [];
    groups.forEach(group => {
      const rowsInGroup = data.filter(row => group[currentColumn] === row[currentColumn]);
      group.totalCounts = rowsInGroup.length;
      const subGroup = this.getSublevel(rowsInGroup, level + 1, groupByColumns, group);
      subGroup.unshift(group);
      subGroups = subGroups.concat(subGroup);
    });
    return subGroups;
  }

  uniqueBy(a, key) {
    const seen = {};
    return a.filter((item) => {
      const k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }

  isGroup(index, item): boolean {
    return item.level;
  }

  togglePannels(type: string) {
    this.allGroupsExpanded = type === 'E' ? true : false;
    this.dataSource.data.forEach(row => {
      if (row.hasOwnProperty('expanded')) {
        row['expanded'] = type === 'E' ? true : false;
      }
    });
    this.dataSource.filter = performance.now().toString();
  }

  //Grouping Code Ends here

  dragStarted(row: StockholderRow, index: number) {
    this.dragDropData = this.dataSource.data.filter(val => val['rowUUID'] && val['year'] === row.year && !(["1", "2", "3", "4", "addRowBtn", "endTotalBal", 'crossCheck'].includes(val['rowUUID'])));
    this.previousIndex = index;
  }

  drop(event: CdkDragDrop<StockholderRow[]>) {
    const originalCopyOfdataSource = JSON.parse(JSON.stringify(this.dataSource.data));
    this.dragDisabled = true;
    const lowestIndex = this.dataSource.data.findIndex(val => val['rowUUID'] && val['rowUUID'] === this.dragDropData[0]['rowUUID']);
    const highestIndex = this.dataSource.data.findIndex(val => val['rowUUID'] && val['rowUUID'] === this.dragDropData[this.dragDropData.length - 1]['rowUUID']);
    const currentIndex = this.previousIndex + (event.currentIndex - event.previousIndex);
    if (lowestIndex <= currentIndex && currentIndex <= highestIndex) {
      moveItemInArray(this.dataSource.data, this.previousIndex, currentIndex);
      this.dataSource = new MatTableDataSource(this.dataSource.data);
      this.table.renderRows();
      this.cdr.detectChanges();

      //api integration
      const newDraggedArray = [];
      let counter = 3;
      this.dataSource.data.forEach((row) => {
        if (row['rowUUID'] && this.dragDropData[0]['year'] === row['year'] && !(["1", "2", "3", "4", "addRowBtn", "endTotalBal", 'crossCheck'].includes(row['rowUUID']))) {
          row['rowSortOrder'] = counter++;
          newDraggedArray.push(row);
        }
      });
      const rowObject = this.createRowObjectForSaving(newDraggedArray, false, false);

      this.apiService.saveStockholderRow(rowObject).subscribe(resp => {
        if (resp) {
          this.toaster.success("Row reordered successfully");
          this.fetchStockHolderData();
        }
      }, error => {
        this.dataSource = new MatTableDataSource(originalCopyOfdataSource);
        this.cdr.detectChanges();
        this.toaster.warning(error.error);
      });

    } else {
      this.toaster.error('You can move between the draggable rows within the year only');
    }
  }

  dropColumn(event: CdkDragDrop<StockholderColumn[]>) {
    moveItemInArray(this.copyColumnsFromApi, event.previousIndex, event.currentIndex);
    this.changedColSortArray = this.copyColumnsFromApi.map(col => col.colSortOrder);

    //change sort order for saving
    this.columnDraggedArray = [];
    let counter = 101 - this.copyColumnsFromApi.length;
    this.copyColumnsFromApi.forEach((column) => {
      if (column.columnUUID !== '1') {
        let newCol = { ...column };
        newCol.colSortOrder = counter++;
        this.columnDraggedArray.push(newCol);
      }
    });
  }

  refreshPreview(isSetKey?: boolean) {
    this.stockService.setStockholderData(this.apiResponse);
    localStorage.setItem("refreshFinancialStatements-StockEquity", "norefresh");
    let obj = {
      "isRefresh": true
    }
    this.sharedService.isStockholderEquityUpdate.next(obj);
    if (isSetKey == undefined) {
      localStorage.setItem('refreshFinancialStatements-StockEquity', "success");
    }
  }
  getFSNotes() {
    this.isSelectAll = false;
    let jsonFileName = this.selectedEngagementDetails.engagementsid + '_notes.json';
    const uploadObj = {
      "module": modules[16],
      "firmId": this.userData.firmUserAcctId,
      "clientId": this.selectedEngagementDetails.clientfirmid,
      "engagementId": this.selectedEngagementDetails.engagementsid,
      "status": 0,
      "folderName": jsonFileName,
      "appSyncId": this.userData.useracctid,
      "extension": 'comp',
    }
    this.apiService.getJsonData(uploadObj).subscribe((response: any) => {
      if (response) {
        this.notes = !response ? [] : JSON.parse(response);
        this.isHideNotesToFS = this.notes.length ? true : false;

        this.notes.forEach(ele => {
          ele['isExpand'] = false;
          ele['is_checked'] = false;
          ele['highlight'] = false;
          if (ele.notes) {
            ele.notes.forEach(element => {
              element['is_checked'] = false;
              element['highlight'] = false;
            });
          }
        })

        this.updateFooter(this.footerNote);
      }
    }, (error) => {
      this.notes = [];
    });
  }
  openNotesOverlay(element: object) {
    this.resetNotesIs_Checked();
    this.notesSource = element
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    this.changednotesLinks(element);
    dialogConfig.height = '100%';
    dialogConfig.position = { 'top': '53px', right: '0' };
    const dialogRef = this.dialog.open(this.notesFSLinkingDialog, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {

    });
  }
  getRowsFromApiResponse() {
    this.listOfRows = [];
    this.apiResponse.year1.rows.forEach(yr1 => {
      this.listOfRows.push(yr1);
    });
    this.apiResponse.year2.rows.forEach(yr2 => {
      this.listOfRows.push(yr2);
    });
  }
  navigateToNotesToFs(id) {
    this.router.navigate(['/trial-balance-working-sheet/fs-notes'], { queryParams: { NoteId: id } });
  }
  changednotesLinks(event?) {
    this.resetNotesIs_Checked();
    const rows = this.apiResponse.year1.rows.concat(this.apiResponse.year2?.rows || []);
    this.notesSource = event ? rows.find(x => x.rowUUID == event.rowUUID) : this.notesSource;
    var obj = event ? event : this.notesSource;
    if (!obj?.notesData) {
      obj.notesData = obj.notes;
    }
    this.disablegreenbutton = (obj.notesData && obj.notesData.length > 0) ? true : false
    if (obj.notesData) {
      for (let k = 0; k < this.notes.length; k++) {
        for (let i = 0; i < obj.notesData.length; i++) {
          if (this.notes[k].engNoteId == obj.notesData[i].engNoteId) {
            this.is_recordChecked(k, 'category');
          } else if (this.notes[k].notes) {
            for (let j = 0; j < this.notes[k].notes.length; j++) {
              if (this.notes[k].notes[j].engNoteId == obj.notesData[i].engNoteId) {
                this.is_recordChecked(k, 'subcategory', j);
              }
            }
          }
        }
      }
    }
  }
  searchNotes() {
    this.notes.forEach(category => {
      if (this.searchKeyword != "" || this.searchKeyword.trim() != "") {
        if (category.name.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
          category['isExpand'] = true;
          category['highlight'] = true;
        } else {
          category['isExpand'] = false;
          category['highlight'] = false;
        }
      } else {
        category['isExpand'] = false;
        category['highlight'] = false;
      }
      if (category.notes && category.notes.length) {
        category.notes.forEach(element => {
          if (this.searchKeyword != "" || this.searchKeyword.trim() != "") {
            if (element.name.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
              element['highlight'] = true;
            } else {
              element['highlight'] = false;
            }
          } else {
            element['highlight'] = false;
          }
        });
      }
    });
  }
  selectAll(event) {
    for (let index = 0; index < this.notes.length; index++) {
      this.notes[index].is_checked = event.checked
      if (this.notes[index].notes) {
        this.notes[index].notes.forEach(element => {
          element.is_checked = event.checked
        });
      }
    }

  }
  is_recordChecked(i, checkedType, j?) {
    if (checkedType == "category") {
      this.notes[i].is_checked = !this.notes[i].is_checked;
      if (this.notes[i].notes) {
        this.notes[i].notes.forEach(element => {
          element.is_checked = this.notes[i].is_checked == true ? true : false
        });
      }
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false
    } else if (checkedType == "subcategory") {
      this.notes[i].notes[j].is_checked = !this.notes[i].notes[j].is_checked;
      this.notes[i].is_checked = this.notes[i].notes.findIndex(x => x.is_checked == false) < 0 ? true : false
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false
    }
  }
  getCheckedNotes() {
    var selected_Records = [];
    this.notes.forEach(elem => {
      if (elem.is_checked) {
        if (elem.notes) {
          selected_Records.push(...elem.notes)
        }
        else {
          selected_Records.push(elem)
        }
      }
      else if (elem.notes) {
        elem.notes.forEach(element => {
          if (element.is_checked) {
            selected_Records.push(element)
          }
        });
      }
    })
    return selected_Records
  }
  saveLinkNotes() {
    const selectedArray = this.getCheckedNotes();
    const linkedNotes = [];
    let selectedYear: any;
    if (this.apiResponse?.year1 && this.apiResponse.year1?.rows && this.apiResponse.year1.rows.find(o => (o.rowId === this.notesSource.rowId && o.rowUUID === this.notesSource.rowUUID))) {
      selectedYear = this.apiResponse.year1.year;
    }
    if (this.apiResponse?.year2 && this.apiResponse.year1?.rows && this.apiResponse.year2.rows.find(o => (o.rowId === this.notesSource.rowId && o.rowUUID === this.notesSource.rowUUID))) {
      selectedYear = this.apiResponse.year2.year;
    }

    selectedArray.forEach(element => {
      const payload = {
        "submoduleId": this.submoduleId,
        "stockholderRowUUID": this.notesSource.rowUUID,
        "engagementsId": this.selectedEngagementDetails.engagementsid,
        "acctYear": selectedYear,
        "noteName": element.name,
        "noteId": element.id,
        "engNoteId": element.engNoteId.toString(),
        "isDelete": false
      }
      linkedNotes.push(payload)
    });
    const obj = {
      "loginId": this.userData.useracctid,
      "rowUUID": this.notesSource.rowUUID,
      "notes": linkedNotes,
      "isNotesUpdate": false,
    }

    this.apiService.saveNotesStockholderEquity(obj).subscribe(resp => {
      if (resp && resp == 'Success') {
        this.toaster.success("Notes saved successfully");
        this.fetchStockHolderData();
      }
    }, (error) => {
      this.toaster.error(error.error);
    })
  }
  resetNotesIs_Checked() {
    if (this.notes && this.notes.length) {
      this.notes.forEach(ele => {
        ele.is_checked = false;
        if (ele.notes) {
          ele.notes.forEach(element => {
            element.is_checked = false;
          });
        }
      })
    }

  }

  ngOnDestroy() {
    if (this.headerFooterSub) {
      this.headerFooterSub.unsubscribe();
    }
    this.subscriptions && this.subscriptions.unsubscribe();
    this.fsService.removeFsDocPreviewPage(DocumentPreviewTypes.STOCK_HOLDERS);
  }


  clickOutside(column: StockholderColumn) {
    if (this.colHeader && this.colHeader.nativeElement.value.trim().length == 0) {
      this.cancelSaveColumn(column);
    }
  }

  updateFooter(note) {
    let preview = document.getElementById("stockholder-preview");
    if (preview) {
      let footerElements = preview.getElementsByClassName("my-custom-footer");
      if (footerElements.length) {
        for (let i = 0; i < footerElements.length; i++) {
          footerElements[i].remove();
        }
        let newFooterText = "<div class='my-custom-footer' style = 'position: sticky;margin-top:auto; bottom: 0px;left:0;padding: 8px 0;background:#ffffff; width: 100%; text-align: center;'> <p style = 'font-family: Arial,sans-serif !important; font-size: 12px;'>" + note + "</p></div>";
        preview.innerHTML += newFooterText;
      }

    }
  }



  public onResizePanelEnd(resizeData: ResizeModel) {
    resizeData.width < resizeData.minWidth ? this.drawer.close() : '';
  }
}
